module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    primary: '#818cf8',
                    darkprimary: '#6366f1',
                    orange: '#f59e0b',
                }
            },
        },
        fontFamily: {
            poppins: ['Poppins', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/galaxy/common/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
